import React from 'react';
import { Link } from '@tanstack/react-router';
import { ShoppingBasket } from 'lucide-react';

export default function BasketButton() {
  return(
    <Link to="/basket">
      <ShoppingBasket size={28} />
    </Link>
  )
}
